import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Panel extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ""
  };

  render() {
    return (
      <section role="main" className={classNames("panel", this.props.className)}>
        {React.Children.map(this.props.children, child => child)}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelMobile.js